import Vue from "vue";
import Component from "vue-class-component";
import { AxiosResponse } from "axios";
import Cookies from "js-cookie";

@Component
export default class AxiosMixin extends Vue {
  loading = false;
  snackbar = false;
  timeout = 2000;

  postForm(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void
  ) {
    this.loading = true;
    window.axios
      .post(url, param, {
        headers: {
          Authorization: "Bearer " + window.token,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        this.loading = false;
        sucessFunc(response);
      })
      .catch(error => {
        if (error.response && error.response.status == 401) {
          console.log("refToken");
          this.refToken(url, param, true, sucessFunc);
        } else {
          this.loading = false;
          this.showErrorMsg(error)
        }
      });
  }

  postJson(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void
  ) {
    this.loading = true;
    window.axios
      .post(url, param, {
        headers: { Authorization: "Bearer " + window.token }
      })
      .then(response => {
        this.loading = false;
        sucessFunc(response);
      })
      .catch(error => {
        if (error.response && error.response.status == 401) {
          console.log("refToken");
          this.refToken(url, param, false, sucessFunc);
        } else {
          this.loading = false;
          this.showErrorMsg(error)
        }
      });
  }

  postJsonCheck(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void
  ) {
    const func = (response: AxiosResponse) => {
      if (response.data.code > 0) {
        alert(response.data.message);
      } else {
        sucessFunc(response);
      }
    };
    this.postJson(url, param, func);
  }

  postJsonWithNoLoading(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void,
    failureFunc: () => void
  ) {
    window.axios
      .post(url, param, {
        headers: { Authorization: "Bearer " + window.token }
      })
      .then(response => {
        sucessFunc(response);
      })
      .catch(error => {
        if (error.response && error.response.status == 401) {
          console.log("refToken");
          this.refToken(url, param, false, sucessFunc);
        } else {
          this.showErrorMsg(error)
          failureFunc()
        }
      });
  }

  postJsonCheckFailWithNoLoading (
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void,
    failureFunc: () => void
  ) {
    const func = (response: AxiosResponse) => {
      if (response.data.code > 0) {
        alert(response.data.message);
        failureFunc();
      } else {
        sucessFunc(response);
      }
    };
    this.postJsonWithNoLoading(url, param, func, failureFunc);
  }

  postJsonBlobResWithNotFound(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void,
    notFoundFunc: (err: any) => void
  ) {
    this.loading = true;
    window.axios
      .post(url, param, {
        responseType: "blob",
        headers: { Authorization: "Bearer " + window.token }
      })
      .then((response: AxiosResponse) => {
        this.loading = false;
        sucessFunc(response);
      })
      .catch(error => {
        if (error.response && error.response.status == 401) {
          console.log("refToken");
          this.refToken(url, param, true, sucessFunc);
        } else {
          this.loading = false;
          if (error.response && error.response.status == 404) {
            notFoundFunc(error)
          } else {
            this.showErrorMsg(error)
          }
        }
      });
  }

  postJsonBlobRes(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void
  ) {
    this.postJsonBlobResWithNotFound(url, param, sucessFunc, (err) => {this.showErrorMsg(err)})
  }

  postJsonBlobResCheck(
    url: string,
    param: object,
    sucessFunc: (res: AxiosResponse) => void
  ) {
    const func = (response: AxiosResponse) => {
      if (response.data.code && response.data.code > 0) {
        alert(response.data.message);
      } else {
        sucessFunc(response);
      }
    };
    this.postJsonBlobRes(url, param, func);
  }

  refToken(
    url: string,
    param: object,
    blobRes: boolean,
    sucessFunc: (res: AxiosResponse) => void
  ) {
    window.axios
      .post(window.base_url + "/auth/refresh", { ref_token: window.reftoken })
      .then(response => {
        window.token = response.data.token;
        Cookies.set("token", response.data.token);
        window.reftoken = response.data.ref_token;
        Cookies.set("reftoken", response.data.ref_token);
        if (blobRes) {
          this.postJsonBlobRes(url, param, sucessFunc);
        } else {
          this.postJson(url, param, sucessFunc);
        }
      })
      .catch(error => {
        if (error.response && error.response.status == 401) {
          this.loading = false;
          alert("セッションがタイムアウトになりました。");
          window.token = "";
          Cookies.set("token", "");
          window.reftoken = "";
          Cookies.set("reftoken", "");
          Cookies.set("isAgree", "");
          window.user_name = "";
          Cookies.set("user_name", "");
          window.office_name = "";
          Cookies.set("office_name", "");
          Cookies.set("isHonobono", "");
          location.href = "/";
        } else {
          this.loading = false;
          this.showErrorMsg(error)
        }
      });
  }

  showErrorMsg(error: any) {
    let msg = "サーバでエラーが発生しました。"
    if (error.response) {
      switch (error.response.status) {
        case 429: // Too Many Requests
          msg = "サーバーが大変混み合っています。申し訳ありませんが、しばらくたってからやり直してください。"
          break
      }
    }
    alert(msg);
    console.log(error);
    console.log(error.response);
  }

  //数値チェック
  isNumber(val: string) {
    const regex = new RegExp(/^[+-]?[0-9]+$/);
    return regex.test(val);
  }

  chkNum(val: string) {
    if (!this.isNumber(val)) {
      return "数値を入力して下さい。";
    }
    return true;
  }
}
